import React, { FC, useEffect, useState } from 'react';
import styles from './index.module.scss';
import dayjs from 'dayjs';
import { FullscreenExitOutlined, FullscreenOutlined, SettingOutlined } from '@ant-design/icons';
import { useHasPermission } from '@/utils/utils';
import { PermissionsType } from '@/common/permissionsConst';

interface IHeaderProps {
  fullBtn: () => void;
  isFullScreen: boolean;
}

const Header: FC<IHeaderProps> = ({ fullBtn, isFullScreen }) => {
  const [time, setTime] = useState(() => dayjs().format('YYYY年M月D日 dddd HH:mm:ss'));
  const hasConfig = useHasPermission(PermissionsType.B_PAINTSHOPOVERVIEWEDIT);

  useEffect(() => {
    const timer = setInterval(() => {
      setTime(dayjs().format('YYYY年M月D日 dddd HH:mm:ss'));
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className={styles.header_area_box}>
      <div className={styles.date_box}>
        <div className={styles.time}>{time}</div>
      </div>
      <div className={styles.title_box}>
        <span className={styles.text}>涂装车间用能数据概览</span>
      </div>
      <div className={styles.set_box}>
        {hasConfig && (
          <div className={styles.btn} onClick={() => window.open('/painting/workshop/overview/config', '_blank')}>
            <SettingOutlined />
            <span className={styles.text}>配置</span>
            <div className={styles.bottomLine} />
          </div>
        )}
        <div className={styles.btn} onClick={fullBtn}>
          {isFullScreen ? <FullscreenExitOutlined /> : <FullscreenOutlined />}
          <span className={styles.text}>{isFullScreen ? '退出' : '全屏'}</span>
          <div className={styles.bottomLine} />
        </div>
      </div>
    </div>
  );
};

export default Header;
